import { useFrame } from "@react-three/fiber"
import { MathUtils, Vector3 } from "three"

export const useCameraMouseRotation = (data) => {
  useFrame(({ mouse, camera }, delta) => {
    if (data.current) {
      const { angle: initialAngle, radius } = data.current
      // calculate curent angle from camera position
      const currentAngle = Math.atan2(camera.position.x, camera.position.z)

      // calculate the new camera position based on the angle and radius
      // and add the mouse x movement to the angle
      // and damp the movement
      const newAngle = MathUtils.damp(
        currentAngle,
        Math.max(initialAngle + mouse.x * 0.1, -Math.PI / 2),
        1,
        delta
      )

      // calculate the new camera position based on the new angle and radius
      camera.position.x = Math.sin(newAngle) * radius
      camera.position.z = Math.cos(newAngle) * radius

      // look at the origin
      const origin = new Vector3(23.327, 4.802, 15.85)
      camera.lookAt(origin)
    }
  })
}
